import { RiseOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Collapse,
  Divider,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Skeleton,
  Typography,
} from "antd";
import { useEffect, useState } from "react";
import {
  toDecodeVIN,
  toGetArticlesCategoriesVehicule,
  toGetCategoriesVehicule,
  toGetVehicleDeatils,
} from "./Api";
import CAxios from "./CAxios";
import { errorMsg } from "./Utils";
const { Option } = Select;

const VIN = () => {
  const [vin, setVin] = useState("");
  const [visible, setVisible] = useState(false);
  const [matchingModels, setMatchingModels] = useState([]);
  const [modelId, setModelId] = useState(-1);
  const [matchingVehicles, setMatchingVehicles] = useState([]);
  const [availableVehicles, setAvailableVehicles] = useState([]);
  const [categories, setCategories] = useState([]);
  const [vehicle, setVehicle] = useState(null);
  const [category, setCategory] = useState(null);
  const [articles, setArticles] = useState([]);
  const [articlesAll, setArticlesAll] = useState([]);
  const [current, setCurrent] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const [article, setArticle] = useState(null);
  const [detailModalVisible, setDetailModalVisible] = useState(false);
  const [brands, setBrands] = useState([]);

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };
  useEffect(() => {
    if (!visible) {
      setCurrent(0);
      setMatchingModels([]);
      setMatchingVehicles([]);
      setCategory(null);
      setVehicle(null);
      setModelId(-1);
    }
  }, [visible]);

  const decodeVIN = () => {
    setCurrent(0);
    setLoading(true);
    setMatchingModels([]);
    setMatchingVehicles([]);
    if (vin.length === 17) {
      toDecodeVIN(vin).then((res) => {
        if (res?.data) {
          setMatchingModels(res.data.matchingModels.array);
          setMatchingVehicles(res.data.matchingVehicles.array);
        }
        setVisible(true);
        setLoading(false);
      });
    } else {
      errorMsg("Le VIN doit avoir 17 caractères");
    }
  };

  useEffect(() => {
    setLoading(true);
    if (vehicle) {
      setCategories([]);
      toGetCategoriesVehicule(vehicle.carId).then((res) => {
        setCategories(res?.categories);
        setLoading(false);
      });
    }
  }, [vehicle]);

  useEffect(() => {
    setLoading(true);

    if (category) {
      setArticles([]);
      toGetArticlesCategoriesVehicule(vehicle.carId, category.categoryId1).then(
        (res) => {
          setArticles(res);
          setArticlesAll(res);
          const l__articles = res;
          setLoading(false);

          const uniqueProductsMap = new Map();

          l__articles?.forEach((product) => {
            if (!uniqueProductsMap.has(product.articleId)) {
              uniqueProductsMap.set(product.articleId, product);
            }
          });

          // Convert map values to array of unique products
          const uniqueProducts = Array.from(uniqueProductsMap.values());

          const brandCounts = {};

          uniqueProducts.forEach((product) => {
            const brand = product.supplierName;
            if (brandCounts[brand]) {
              brandCounts[brand]++;
            } else {
              brandCounts[brand] = 1;
            }
          });

          setBrands(brandCounts);
        },
      );
    }
  }, [category]);
  useEffect(() => {
    setLoading(true);
    getVehicleDetails();
  }, [modelId]);
  const getVehicleDetails = async () => {
    if (modelId !== -1) {
      var list = matchingVehicles.filter((el) => el.modelId === modelId);
      for (let index = 0; index < list.length; index++) {
        const res = await toGetVehicleDeatils(list[index].carId);
        list[index] = res?.vehicleTypeDetails;
      }
      setAvailableVehicles(list);
    }
    setLoading(false);
  };

  const toGetArticleDetails = async (article) => {
    console.log(article);
    setLoadingModal(true);
    setDetailModalVisible(true);

    const { data } = await CAxios.post(`/api/tecdoc/detail`, {
      code: Math.abs(article.articleId),
    });
    // setImage(data.docId);
    setArticle(data.success?.result?.article);
    setLoadingModal(false);
  };

  const toCloseModal = () => {
    setDetailModalVisible(false);
    setArticle(null);
    setLoadingModal(false);
  };

  const onChangeMarque = (e) => {
    if (e == "Tout") {
      setArticles(articlesAll);
    } else {
      setArticles(articlesAll.filter((a) => a.supplierName == e));
    }
  };
  const FileDisplay = (fileUrl, alt) => {
    const isImage = /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(fileUrl);
    const isPdf = /\.pdf$/i.test(fileUrl);

    return (
      <div>
        {isImage && (
          <img
            src={fileUrl}
            alt={alt || "Image file"}
            style={{ maxWidth: "100%", height: "auto" }}
          />
        )}
        {isPdf && (
          <embed
            src={fileUrl}
            type="application/pdf"
            width="100%"
            height="600px"
            style={{ border: "1px solid #ccc" }}
          />
        )}
        {!isImage && !isPdf && <p>File type not supported or unknown.</p>}
      </div>
    );
  };

  return (
    <>
      <Input.Search
        type="text"
        placeholder="VIN"
        style={{ marginTop: "10px" }}
        onChange={(e) => setVin(e.target.value)}
        onSearch={() => decodeVIN(vin)}
      />
      <Modal
        className="smtv-modal modal-large"
        style={{ minHeight: "10vh" }}
        visible={visible}
        title={<> {current > 0 && <Button onClick={prev}>Précédent</Button>}</>}
        onCancel={() => setVisible(false)}
      >
        {current === 0 && (
          <>
            <Typography.Title type="secondary" level={1}>
              Modèles correspondants ({matchingModels.length})
            </Typography.Title>
            <Row gutter={16}>
              {!loading && matchingModels.length === 0 && (
                <Typography.Title type="danger" level={5}>
                  Aucun modèle correspondant
                </Typography.Title>
              )}
              {matchingModels.map((el) => (
                <Col span={8}>
                  <Card
                    bordered
                    onClick={() => {
                      setModelId(el.modelId);
                      next();
                    }}
                    style={{
                      backgroundColor: modelId === el.modelId ? "#E5E5E5" : "",
                      cursor: "pointer",
                    }}
                  >
                    <Typography.Title style={{ cursor: "pointer" }} level={5}>
                      {el.modelName}
                    </Typography.Title>
                  </Card>
                </Col>
              ))}
            </Row>
          </>
        )}
        {current === 1 && (
          <>
            <Typography.Title type="secondary" level={1}>
              Véhicules correspondantes ({availableVehicles.length})
            </Typography.Title>

            <table className="ant-table" style={{ width: "100%" }}>
              <thead className="ant-table-thead">
                <tr>
                  <th className="ant-table-cell">Véhicule</th>
                  <th className="ant-table-cell">Année de fabrication</th>
                  <th className="ant-table-cell">HP</th>
                  <th className="ant-table-cell">kW</th>
                  <th className="ant-table-cell">Code(s) du moteur</th>
                </tr>
              </thead>

              {availableVehicles.map((el, i) => (
                <tr
                  key={i}
                  onClick={() => {
                    setVehicle(el);
                    next();
                  }}
                  className={i % 2 != 0 && "auto--background-grey"}
                  style={{
                    fontSize: "18px",
                    lineHeight: "50px",
                    padding: "10px",
                    cursor: "pointer",
                  }}
                >
                  <td className="ant-table-cell">
                    {el.manufacturerName +
                      " - " +
                      el.modelType +
                      " " +
                      el.typeEngineName}
                  </td>
                  <td className="ant-table-cell">
                    {el.constructionIntervalStart +
                      " -> " +
                      el.constructionIntervalEnd}
                  </td>
                  <td className="ant-table-cell">{parseInt(el.powerPs)}</td>
                  <td className="ant-table-cell">{parseInt(el.powerKw)}</td>
                  <td className="ant-table-cell">{el.engCodes}</td>
                </tr>
              ))}
            </table>
          </>
        )}
        {current === 2 && (
          <>
            <Typography.Title type="secondary" level={1}>
              Catégories
            </Typography.Title>

            <Row gutter={16}>
              {categories
                .filter((el) => el.categoryName2 == null)
                .map((el) => (
                  <Col span={8}>
                    <Collapse bordered={false}>
                      <Collapse.Panel
                        header={
                          <Typography.Title
                            style={{ cursor: "pointer" }}
                            level={5}
                          >
                            {el.categoryName1}
                          </Typography.Title>
                        }
                        key={el.categoryId1}
                      >
                        {categories
                          .filter(
                            (x) =>
                              x.categoryId1 === el.categoryId1 && x.level == 2,
                          )
                          .map((y) => (
                            <Typography.Title
                              onClick={() => {
                                setCategory(y);
                                next();
                              }}
                              style={{ cursor: "pointer" }}
                              level={5}
                            >
                              {y.categoryName2}
                            </Typography.Title>
                          ))}
                      </Collapse.Panel>
                    </Collapse>
                  </Col>
                ))}
            </Row>
          </>
        )}
        {current === 3 && (
          <>
            <Typography.Title type="secondary" level={1}>
              Articles ({articles.length})
            </Typography.Title>
            <Form.Item label="Marque" name="marque" style={{ marginBottom: 0 }}>
              <Select
                showSearch
                onChange={(e) => onChangeMarque(e)}
                style={{ width: "200px" }}
              >
                <Option value="Tout">Tout</Option>
                {Object.entries(brands).map(([brand, count]) => (
                  <Option value={brand}>{brand + "(" + count + ")"}</Option>
                ))}
              </Select>
            </Form.Item>
            {null != articles && articles.length > 0 && (
              <table className="ant-table" style={{ width: "100%" }}>
                <thead className="ant-table-thead">
                  <tr>
                    <th className="ant-table-cell">Image</th>
                    <th className="ant-table-cell">Référence</th>
                    <th className="ant-table-cell">Article</th>
                    <th className="ant-table-cell">Marque</th>
                    <th className="ant-table-cell">Prix U TTC</th>
                    <th className="ant-table-cell">Stock</th>
                    <th className="ant-table-cell"></th>
                  </tr>
                </thead>

                <tbody className="ant-table-tbody">
                  {articles.map((element, i) => (
                    <tr
                      key={i}
                      className={
                        element.inStock
                          ? "inStock"
                          : i % 2 != 0 && "auto--background-grey"
                      }
                    >
                      <td>
                        <img
                          src={element.s3image}
                          style={{ width: "150px", maxHeight: "150px" }}
                        />
                      </td>
                      <td className="ant-table-cell">
                        <b style={{ color: "#2696d3", fontSize: "1rem" }}>
                          {element.inStock
                            ? element.data.s__reference
                            : element.articleNo}
                        </b>
                      </td>

                      <td className="ant-table-cell">
                        <b>{element.articleProductName}</b>
                      </td>
                      <td className="ant-table-cell">{element.supplierName}</td>

                      {null != element.data ? (
                        <>
                          <td className="ant-table-cell">
                            <b>
                              {element.data.l__prixVenteTTC.toFixed(3)}
                              <span
                                style={{
                                  fontWeight: "normal",
                                  verticalAlign: "text-top",
                                }}
                              >
                                DT
                              </span>
                            </b>
                          </td>
                          <td className="ant-table-cell">
                            <span
                              className={
                                element.data.stock <= 0
                                  ? "auto--color-danger"
                                  : element.data.stock < element.data.l__seuil
                                  ? "auto--color-warning"
                                  : "auto--color-success"
                              }
                            >
                              {element.data.stock}
                            </span>
                            <br />
                            <span>Emp</span> :{" "}
                            <b style={{ fontSize: "0.8rem" }}>
                              {Array.isArray(element?.data.emplacement) &&
                                element?.data.emplacement?.map((e) => (
                                  <>
                                    <div>{e.stock + " => " + e.emp}</div>
                                  </>
                                ))}
                            </b>
                          </td>
                        </>
                      ) : (
                        <>
                          <td className="ant-table-cell"></td>{" "}
                          <td className="ant-table-cell"></td>
                        </>
                      )}
                      <td
                        className="ant-table-cell"
                        style={{ display: "inline-flex" }}
                      >
                        {!element.inStock && (
                          <Button
                            type="link"
                            // onClick={(e) =>
                            //   addFromTecdoc({
                            //     ...element,
                            //     fullName: element.articleProductName,
                            //     code: element.articleId,
                            //     ref: element.articleNo,
                            //     brand: { name: element.supplierName },
                            //   })
                            // }
                            icon={<img src="/images/plusVente.svg" />}
                          />
                        )}
                        {element.inStock && (
                          <Button
                            type="link"
                            //  onClick={(e) => setArticleHistory(element.data)}
                            icon={<RiseOutlined />}
                          ></Button>
                        )}
                        <Button
                          type="link"
                          icon={
                            <img
                              src="/images/detailArticle.svg"
                              style={{ height: "90%" }}
                            />
                          }
                          onClick={(e) => toGetArticleDetails(element)}
                          style={{ marginLeft: 1 }}
                        ></Button>

                        {/* { element.inStock && null != addItem && (
                      <Button
                        type="link"
                        style={{ marginLeft: 1 }}
                        icon={<img src="/images/toAdd.svg" />}
                        // onClick={() => toAddItem(element.data, achat)}
                      ></Button>
                    )} */}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </>
        )}
        <Skeleton loading={loading} avatar />

        <Modal
          className="smtv-modal"
          width={"800px"}
          title={
            null != article &&
            article.articleNo + " " + article.articleProductName
          }
          visible={detailModalVisible}
          maskClosable={false}
          onCancel={(e) => toCloseModal()}
          footer={[
            <Button key="back" onClick={(e) => toCloseModal(false)}>
              Fermer
            </Button>,
          ]}
        >
          <Skeleton active avatar loading={loadingModal} />

          {article && (
            <>
              <Row justify="center">
                <Col span={12} justify="center">
                  {null != article &&
                    article.s3image != "" &&
                    FileDisplay(article.s3image, article.articleProductName)}
                </Col>
                <Col span={12}>
                  <Divider>Caractéristiques de l'article</Divider>
                  <table className="ant-table">
                    <tbody className="ant-table-tbody">
                      {article?.allSpecifications?.map((o, x) => (
                        <tr key={x}>
                          <td className="ant-table-cell">
                            <Typography.Title level={5}>
                              <strong>{o.criteriaName}</strong>
                            </Typography.Title>
                          </td>

                          <td className="ant-table-cell">
                            <Typography.Text>{o.criteriaValue}</Typography.Text>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Col>
              </Row>
              <Row justify="center">
                <Col span={12}>
                  <Divider>References d'origine</Divider>

                  <table className="ant-table">
                    <tbody className="ant-table-tbody">
                      {article.oemNo?.map((o, x) => (
                        <tr key={x}>
                          <td className="ant-table-cell">
                            <Typography.Title level={5}>
                              <strong>{o.oemBrand}</strong>
                            </Typography.Title>
                          </td>

                          <td className="ant-table-cell">
                            <Typography.Link>{o.oemDisplayNo}</Typography.Link>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Col>
                <Col span={12}>
                  <Divider>Compatibilité</Divider>

                  <table className="ant-table">
                    <tbody className="ant-table-tbody">
                      {article.compatibleCars
                        ?.sort(
                          (a, b) => a.manufacturerName - b.manufacturerName,
                        )
                        ?.map((o, x) => (
                          <tr key={x}>
                            <td className="ant-table-cell">
                              <Typography.Title level={5}>
                                <strong>{o.manufacturerName}</strong>
                              </Typography.Title>
                            </td>

                            <td className="ant-table-cell">
                              <Typography.Link>
                                {o.modelName + " " + o.typeEngineName}
                              </Typography.Link>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </Col>
              </Row>
            </>
          )}
        </Modal>
      </Modal>
    </>
  );
};

export default VIN;
